import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import { removeDateHyphens } from '@utils/date';

export const useRedirectToToday = (basePath: string) => {
  const navigate = useNavigate();

  useEffect(() => {
    const today = removeDateHyphens(new Date().toLocaleDateString('fr-CA'));
    navigate(`${basePath}/${today}`, { replace: true });
  }, [basePath]);
};
